import(/* webpackMode: "eager" */ "/app/apps/frontend/app/(dashboard)/video-generation/page.tsx");
